import type { SxProps, Theme } from '@mui/material/styles';
import { registerColors } from '../../styles/colors';

export const heroStackSx: SxProps<Theme> = {
  overflow: 'hidden',
  '@media (max-width:1023px)': { display: 'none' },
};

export const formPanelSx: SxProps<Theme> = {
  padding: 'clamp(16px, 5vw, 8%)',
  backgroundColor: registerColors.backgroundPanel,
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  opacity: 1,
  position: 'relative',
  zIndex: 0,
  '@media (max-height: 750px)': { overflowY: 'auto', justifyContent: 'flex-start' },
  '@media (max-width:1023px)': {
    width: '100%',
    padding: 'clamp(16px, 6vw, 48px)',
  },
};
